export const apiErrorMessages = {
  INVALID_REQUEST: 'Please provide a valid request.',
  VALIDATE_FORM_GENERIC_MESSAGE:
    'Please update the form with correct values and proceed.',
  MISSING_REQUIRED_PARAMETER: {
    data_classification: 'Please select data classification',
    sharee_email_addresses: 'Please enter sharee email ID',
    business_justification: 'Please enter business justification',
    data_source: 'Please enter data source',
    infosec_domain: 'Please select organisation',
    duration_in_days: 'Please enter duration in days',
  },
  INVALID_PARAMETER_VALUE: {
    duration_in_days:
      'Only numbers are allowed. Minimum 1 Day, Maximum 365 Days',
    data_classification: 'Please provide valid data classification',
    infosec_domain: 'Please provide valid infosec domain',
  },
  INVALID_STRING_LENGTH: {
    business_justification:
      'Please provide a business justification between 50 and 1000 characters.',
    data_source:
      'Please provide source of data being shared between 50 and 1000 characters.',
    comment: 'Please provide a comment between 15 and 1000 characters.',
  },
  INVALID_PARAMETER_SYNTAX: {
    data_classification: 'Please provide valid data classification',
    sharee_email_addresses: `Please provide valid sharee email ID's`,
    business_justification: 'Please provide valid business justification',
    data_source: 'Please provide valid source of data being shared',
    infosec_domain: 'Please provide valid infosec domain',
    duration_in_days: 'Please provide valid duration in days',
  },
  INVALID_ARRAY_LENGTH: {
    sharee_email_addresses: 'Please enter up to 10 email addresses of sharees',
  },
  INVALID_INTEGER_MIN_VALUE: {
    duration_in_days:
      'Please enter duration in days. Minimum 1 Day, Maximum 365 Days',
  },
  INVALID_INTEGER_MAX_VALUE: {
    duration_in_days:
      'Please enter valid duration in days. Minimum 1 Day, Maximum 365 Days',
  },
  UNPROCESSABLE_ENTITY:
    'The requested action could not be performed. Please try again.',
  OPERATION_NOT_ALLOWED:
    'The requested action could not be performed for the current status',
  INVALID_INFOSEC_TICKET_STATE:
    'Please get the InfoSec ticket approved before resuming the request.',
  INTERNAL_SERVER_ERROR: 'Something went wrong. Please try again later.',
  GENERAL: {
    somethingWentWrong: 'Something went wrong. Please try again later.',
    sessionExpired: 'Your session has expired. Please login again.',
    unauthorized: 'You are not authorized to access this',
    missingRequestId: 'Missing request ID',
    invalidRequestId: 'Invalid request ID',
    unsupportedAction: 'Unsupported action: {action}',
    unknownError: 'Unknown error occurred',
  },
  RESOURCE_NOT_FOUND:
    'The requested resource was not found. Please try again later',
  NOT_AUTHORIZED:
    'You are not authorized to perform this action. Please login back and try again',
}
